import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

type BookmarkProps = SvgProps & {
    className?: string;
};

export const BookmarkIcon: FunctionComponent<BookmarkProps> = (props) => (
    <svg {...propsHelperRem(3.6, 3.6, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.05 13.5V9.3h4.575V5.7H28.05V1.125h-3.6V5.7h-4.2v3.6h4.2v4.2h3.6ZM11.475 5.625h4.275v3.6h-4.275v16.353l4.868-2.524 1.657-.86 1.657.86 4.868 2.524V18h3.6v13.5l-3.6-1.867L18 26.25l-6.525 3.383-3.6 1.867V5.625h3.6Z"
        />
    </svg>
);
